angular.module('impactx.configuration', []);